// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"a2445ec9","131":"7ea78ada","209":"6e037902","658":"7c9d231c","881":"80769083"}[chunkId] + ".chunk.css";
};